import { render } from "./SalesMainView.vue?vue&type=template&id=83a220a4"
import script from "./SalesMainView.vue?vue&type=script&lang=js"
export * from "./SalesMainView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__